import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './style/navbar.scss';





class Navbar extends Component {

    constructor(props) {
        super(props);

        this.state = {

        };
    }


    render() {




        return (
            <div className="cover-navbar">
                <div className="menu-bar">
                    <nav className="navbar navbar-expand-lg navbar-light">
                        <a className="navbar-brand" href="/">
                            <img className="img-fluid" src="/img/logo/logo.png" />
                        </a>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav mr-auto">
                                <li className="nav-item active">
                                    <a className="nav-link" href="/">หน้าแรก <span className="sr-only">(current)</span></a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/promotion">โปรโมชั่น</a>
                                </li>

                                <li className="nav-item">
                                    <a className="nav-link" href="/store">ร้านค้า</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/contact">ติดต่อเรา</a>
                                </li>
                            </ul>
                            <div className="form-inline my-2 my-lg-0">

                                {
                                    localStorage.getItem("firstname") ? <ul className="navbar-nav mr-auto">
                                    <li className="nav-item dropdown">
                                        <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            {localStorage.getItem("firstname") + " " + localStorage.getItem("lastname")}
                                        </a>
                                        <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                            <a className="dropdown-item" href="#">Profile</a>
                                            <a className="dropdown-item" onClick={()=>{localStorage.clear(); setTimeout(() => { window.location.href = "/"}, 1000) }}>Logout</a>
                                        </div>
                                    </li>
                                </ul> : <ul className="navbar-nav mr-auto">
                                    <li className="nav-item">
                                        <a className="nav-link br-left" href="/auth">เข้าสู่ระบบ <span className="sr-only">(current)</span></a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href="/create_user">สมัครสมาชิก</a>
                                    </li>
                                </ul>
                                }




                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        )
    }
}

export default Navbar;
